import React from "react";
import { ContentDiv } from "components/containers";
import {
  Title,
  NewsSection,
  AboutSection,
  SectionHeader,
  Resources,
  Releases,
  News
} from "./styles";
import { HighlightedSection } from "components/containers";
import { useTranslation } from "react-i18next";
import { Phone, Mail, Download } from "../../../components/Icons/Generic";
import { ResponsiveImage } from "../../../components/ResponsiveImage";
import { StyledButton } from "../../../components/generic";
import { BlogCard } from "../../../components/BlogCard";
import { Trouw, NRC, AD } from "../../../components/Icons/MediaLogos";
import { useNavigate } from "react-router-dom";
import { MISSION_ROUTE } from "utils/constants";
import { OrangePlayFull } from "components/Icons/OrangePlayFull";
import { useIsMobile } from "../../../utils/hooks/useWindowSize";
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/interfaces";

export const Press: React.FC = () => {
  const { t, i18n } = useTranslation("press");
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const [textWidth, setTextWidth] = React.useState<string>("275px");

  React.useEffect(() => {
    if (isMobile) {
      setTextWidth("75px");
    } else {
      setTextWidth("275px");
    }
  }, [isMobile]);
  const seo = t("press.seo", { returnObjects: true }) as ISeo;

  return (
    <ContentDiv>
      {seo && <HeaderSEO {...seo} />}
      <Title>{t("press.title")}</Title>
      <OrangePlayFull
        viewView={textWidth}
        viewHeight="12px"
        marginBottom="0.3em"
        strokeWidth="16"
      />
      <NewsSection>
        <ResponsiveImage
          className={"image"}
          imgSrc={"rootpage/press/Daan Donkers interview met SBS6"}
          mobileSize={"95vw"}
          tabletSize={"40vw"}
          desktopSize={"50vw"}
        />
        <div>
          <SectionHeader>{t("press.newsSection.header")}</SectionHeader>
          <h2>{t("press.newsSection.title")}</h2>
          <p>{t("press.newsSection.description")}</p>
          <HighlightedSection>{Mail}daan@hospihousing.com</HighlightedSection>
          <HighlightedSection>{Phone}06 81872586</HighlightedSection>
        </div>
      </NewsSection>
      <AboutSection>
        <ResponsiveImage
          className={"image"}
          imgSrc={
            "rootpage/press/Oprichters Hospi Housing Joost Daan en Maurits op bankje in tuin"
          }
          mobileSize={"95vw"}
          tabletSize={"40vw"}
          desktopSize={"50vw"}
        />
        <div>
          <SectionHeader>{t("press.aboutSection.header")}</SectionHeader>
          <h2>{t("press.aboutSection.title")}</h2>
          <p>{t("press.aboutSection.description")}</p>
          <StyledButton
            onClick={() =>
              navigate(`/${i18n.language}${MISSION_ROUTE.slice(5)}`)
            }
          >
            {t("press.aboutSection.button")}
          </StyledButton>
        </div>
      </AboutSection>
      <SectionHeader>{t("press.pressKit.header")}</SectionHeader>
      <h2>{t("press.pressKit.title")}</h2>
      <p>{t("press.pressKit.description")}</p>
      <Resources>
        <a href={"/files/Fotos founders HospiHousing.zip"} download>
          <HighlightedSection outline={true}>
            {t("press.pressKit.button.1")}
            {Download}
          </HighlightedSection>
        </a>
        <a href={"/files/Logos HospiHousing.zip"} download>
          <HighlightedSection outline={true}>
            {t("press.pressKit.button.2")}
            {Download}
          </HighlightedSection>
        </a>
        <a href={"/files/Impression pictures HospiHousing.zip"} download>
          <HighlightedSection outline={true}>
            {t("press.pressKit.button.3")}
            {Download}
          </HighlightedSection>
        </a>
        <a href={"/files/Pictures Platform HospiHousing.zip"} download>
          <HighlightedSection outline={true}>
            {t("press.pressKit.button.4")}
            {Download}
          </HighlightedSection>
        </a>
      </Resources>
      <SectionHeader>{t("press.pressReleases.header")}</SectionHeader>
      <h2>{t("press.pressReleases.title")}</h2>
      <Releases>
        <BlogCard
          post_id={"gemeente-maastricht-start-samenwerking-hospi-housing"}
          short_desc={true}
        />
        <BlogCard
          post_id={"gemeente-groningen-start-samenwerking-hospi-housing"}
          short_desc={true}
        />
        <BlogCard
          post_id={"gemeente-leiden-start-samenwerking-hospi-housing"}
          short_desc={true}
        />
      </Releases>
      <SectionHeader>{t("press.inNews.header")}</SectionHeader>
      <h2>{t("press.inNews.title")}</h2>
      <p>{t("press.inNews.description")}</p>
      <News>
        <div
          onClick={() =>
            window.open(
              "https://www.nrc.nl/nieuws/2022/10/03/de-hospita-als-oplossing-voor-nijpende-kamernood-a4143926",
              "_blank"
            )
          }
        >
          {NRC}
          <h2>3 oktober 2022</h2>
          <p>De hospita als oplossing voor nijpende kamernood</p>
        </div>
        <div
          onClick={() =>
            window.open(
              "https://www.ad.nl/binnenland/de-comeback-van-de-hospita-binnen-twee-uur-veertig-reacties-br-br~aa5b8f9b/",
              "_blank"
            )
          }
        >
          {AD}
          <h2>8 september 2022</h2>
          <p>De comeback van de hospita: ‘Binnen twee uur veertig reacties’</p>
        </div>
        <div
          onClick={() =>
            window.open(
              "https://www.trouw.nl/binnenland/een-internationale-student-in-huis-harry-79-vindt-het-geen-probleem~bbd6fe9b/",
              "_blank"
            )
          }
        >
          {Trouw}
          <h2>7 augustus 2022</h2>
          <p>
            Een internationale student in huis? Harry (79) vindt het geen
            probleem
          </p>
        </div>
      </News>
    </ContentDiv>
  );
};
